import { getDivideRuleList } from '@/api/domain/finance'
import ENUM from '@/pages/finance/partnerAccountOpen/enum'
import { convertNumber } from '@/utils'
import { limitMoreZero } from '@/utils/validate'
import { operateMaxShowLength } from '@/store/dict/config'

export default function config() {
  return {
    configData: {
      formData: {
        list: [
          {
            el: 'input',
            itemConfig: {
              label: '规则ID',
              prop: 'ruleId',
            },
            elConfig: {
              maxLength: 20,
              events: {
                input: (e) => {
                  // eslint-disable-next-line no-shadow
                  limitMoreZero(e, (e) => {
                    this.$set(this.configData.formData.formProps.model, 'ruleId', e)
                  }, 20, false)
                },
              },
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '规则名称',
              prop: 'ruleName',
            },
            elConfig: {
              maxLength: 20,
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '转出方',
              prop: 'transferorId',
            },
            elConfig: {
              options: {
                label: 'accountName',
                value: 'accountId',
                list: [],
              },
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '接收方',
              prop: 'receiverId',
            },
            elConfig: {
              options: {
                label: 'accountName',
                value: 'accountId',
                list: [],
              },
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '状态',
              prop: 'state',
            },
            elConfig: {
              options: {
                label: 'label',
                value: 'value',
                list: this.dictParseList(ENUM.STATE),
              },
            },
          },
        ],
        formProps: {
          model: {
            ruleId: '',
          },
        },
        customizeReset: () => {
          this.configData.formData.formProps.model.ruleId = ''
        },
      },
      tableData: {
        columns: [
          {
            name: 'ruleId',
            columnProps: {
              prop: 'ruleId',
              label: '规则ID',
              minWidth: 150,
            },
          },
          {
            name: 'ruleName',
            columnProps: {
              label: '规则名称',
              prop: 'ruleName',
              minWidth: 180,
            },
          },
          {
            name: 'transferorName',
            columnProps: {
              label: '转出方',
              prop: 'transferorName',
              minWidth: 180,
            },
          },
          {
            name: 'receiverName',
            columnProps: {
              label: '接收方',
              prop: 'receiverName',
              minWidth: 150,
            },
          },
          {
            name: 'divideTime',
            columnProps: {
              label: '转账日',
              prop: 'divideTime',
              minWidth: 180,
            },
          },
          {
            name: 'divideAmount',
            columnProps: {
              label: '单次转账金额(元)',
              prop: 'divideAmount',
              minWidth: 180,
            },
            getText: ({ row }) => convertNumber(row.divideAmount),
          },
          {
            name: 'state',
            columnProps: {
              label: '启用状态',
              prop: 'state',
              minWidth: 180,
            },
            render: ({ row }) => {
              return this.$createElement('span', {}, [
                `${ENUM.STATE[row.state]} `,
                row.approval && '(',
                row.approval && this.$createElement('i', {
                  class: 'el-icon-warning',
                }),
                row.approval && ` ${row.approval})`,
              ])
            },
          },
          {
            name: 'operate',
            columnProps: {
              label: '操作',
              width: 240,
              fixed: 'right',
            },
            maxShowLength: operateMaxShowLength,
            type: 'operate',
            getOperateList: ({ row }) => {
              const result = []
              if (this.checkBankChannelPermission('editTransferRulesConfig', 'editTransferRulesConfigWangshang', this.bankChannelType)) {
                result.push({ name: 'editTransferRulesConfig', label: '编辑', action: () => this.editRule(row) })
              }
              if (this.checkBankChannelPermission('startTransferRulesConfig', 'startTransferRulesConfigWangshang', this.bankChannelType) && row.state === ENUM.STATE_ENUM.disable) {
                result.push({ name: 'startTransferRulesConfig', label: '启用', action: () => this.handleEnableState(row) })
              }
              if (this.checkBankChannelPermission('endTransferRulesConfig', 'endTransferRulesConfigWangshang', this.bankChannelType) && row.state === ENUM.STATE_ENUM.enable) {
                result.push({ name: 'endTransferRulesConfig', label: '停用', action: () => this.handleDisableState(row) })
              }
              if (this.checkBankChannelPermission('manualTransfer', 'manualTransferWangshang', this.bankChannelType)) {
                result.push({ name: 'applyDivide', label: '手动转账', action: () => this.callManualDivideDialog(row) })
              }
              return result
            },
          },
        ],
        apiFn: getDivideRuleList,
      },
      isShowDepartment: false,
    },
  }
}
